import { Controller } from "@hotwired/stimulus"

// Handles the Webhook Field Mapping form:
// - Clears and disables the target_field select when "Ignore" is checked
// - Re-enables the select when "Ignore" is unchecked
export default class extends Controller {
  static targets = ["targetField"]

  toggleIgnored(event) {
    const ignored = event.target.checked
    const select = this.targetFieldTarget

    if (ignored) {
      select.value = ""
      select.disabled = true
    } else {
      select.disabled = false
    }
  }
}
